import Joi from "joi";
import errorsResolver from "../../../validation/schemeUtils";

const rejectionModalValidationScheme = Joi.object({
  decision: Joi.object({
    value: Joi.string()
    .required()
    .error(errorsResolver({
      required: "Причина отклонения заявки обязательное поле",
    })),
  
    label: Joi.string()
    .min(3)
    .max(250)
    .pattern(new RegExp('^[а-яА-ЯёЁ0-9\\-()/" _.,;:!? ]{1,250}$'))
    .required()
    .error(errorsResolver({
        required: "Причина отклонения заявки обязательное поле",
        pattern: "Поле ввода содержит некорректные символы",
        min: "Причина отклонения должна содержать не менее 3 символов",
        max: "Причина отклонения должна содержать не более 250 символов",
    }))
  })
    .invalid(null)
    .required()
    .error(errorsResolver({
        required: "Причина отклонения заявки обязательное поле",
        invalid: "Причина отклонения заявки обязательное поле"
    }))
});

export default rejectionModalValidationScheme;
